module.exports = __webpack_public_path__ + "img/VL_03_01.7bee3050.png";